module.exports = __webpack_public_path__ + "static/media/BgRegister.7af5d21a.png";